export class TxnCatGroup {
    public _id: string = "";
    public name: string = "";
}

export class TxnCat {
    public _id: string = "";
    public name: string = "";
    public groups: Record<string, TxnCatGroup> = {};
}

export const GROUPS: TxnCatGroup[] = [
    {
        "_id": "group_clasr0ysw0010hk4mf2dca4y8",
        "name": "Appearance"
    },
    {
        "_id": "group_clasr0ysw000zhk4m0cru14rw",
        "name": "Education"
    },
    {
        "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
        "name": "Food"
    },
    {
        "_id": "group_clasr0ysw000yhk4mddaobwu7",
        "name": "Health"
    },
    {
        "_id": "group_clasr0ysw000uhk4m20nvc6m1",
        "name": "Household"
    },
    {
        "_id": "group_clasr0ysw000thk4mefilhht7",
        "name": "Housing"
    },
    {
        "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
        "name": "Lifestyle"
    },
    {
        "_id": "group_clasr0ysw0012hk4mgru5dgy7",
        "name": "Professional Services"
    },
    {
        "_id": "group_clasr0ysw000whk4m577xhmf3",
        "name": "Transport"
    },
    {
        "_id": "group_clasr0ysw000vhk4m46ce9nrt",
        "name": "Utilities"
    }

];

export const CATEGORIES: TxnCat[] = [
    {
        "_id": "nzfcc_ckouvvz87005f08mlfta1ecg6",
        "name": "Accountancy, bookkeeping, auditing, and tax services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz9d005n08ml5by905rq",
        "name": "Advertising and marketing services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxvv000h08ml7xbxeoht",
        "name": "Agricultural supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyy7004g08mlc3hedgqz",
        "name": "Air transport services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_clahcjf2o000208jtb9krgphr",
        "name": "Airports",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyn5002u08mlbacc93hw",
        "name": "Antique stores and repair",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvye7001s08mld9hj5q2y",
        "name": "Apparel and accessory stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz38005408mlhr8a57nj",
        "name": "Appliance and furniture rentals",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyqe003808ml73z05dr5",
        "name": "Appliance repair and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz6k005908mlaluc5mhg",
        "name": "Architect, engineering, and surveying services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyo7002z08ml9oy0a5q1",
        "name": "Art and craft stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyo8003008ml29qq5hn8",
        "name": "Art stores, dealers, and galleries",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzju007608mldg1lf61f",
        "name": "Attractions, museums, zoos, amusement parks, circuses, exhibits",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvytt003r08ml0nc1h7im",
        "name": "Automotive body repair and painting services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy4q001008ml3dl13w1q",
        "name": "Automotive parts and accessories",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyuc003t08mlb3v45h5p",
        "name": "Automotive repair and servicing",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy98001a08ml3l180boh",
        "name": "Bakeries",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyvh004108mlfau3hrm2",
        "name": "Bars, pubs, nightclubs",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyin002e08ml5ahteewu",
        "name": "Bicycle stores, rentals, and repairs",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyi5002d08ml106b4vlx",
        "name": "Boat dealers",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz37005308mla176dhu7",
        "name": "Boat rentals",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyx4004a08ml4rop060m",
        "name": "Boat transport services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pdepxy000009i4bdn9hzfb",
        "name": "Body corporate",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000thk4mefilhht7",
                "name": "Housing"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyjq002g08mlc0h7f3ke",
        "name": "Book stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxus000e08mlem1o2ha2",
        "name": "Building and carpentry services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxz6000m08ml620k803p",
        "name": "Building supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_clahcegjo000008l250of62eq",
        "name": "Bus and shuttle transport services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzb0005x08mldzw1a2lr",
        "name": "Business services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckpymsz13000009l2alfj3mw4",
        "name": "Business software and cloud services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyw1004408mlhy158i7j",
        "name": "Cafes and restaurants",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz4a005508ml8yfj5utb",
        "name": "Car and motorcycle rentals",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyrj003f08mldndoev9v",
        "name": "Car, truck, and motorcycle dealers",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzit007208ml20wedcsf",
        "name": "Casino, lottery, and other gambling services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyw0004308ml42nd6gao",
        "name": "Caterers",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxwg000j08ml6bpqetr6",
        "name": "Chemical products and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyc1001l08ml50ov60j5",
        "name": "Child and infant clothing",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzc5006408mlbq4td5dm",
        "name": "Childcare services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzfh006l08mldtd37dvx",
        "name": "Chiropodists and podiatrists",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzfd006i08ml2xnjeo2m",
        "name": "Chiropractors and osteopaths",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyau001d08mlecosa2ds",
        "name": "Cigarette, vape, and other smoking products",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzhm006s08ml5q7r9iof",
        "name": "Cinemas",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz9v005p08mlbaeeakka",
        "name": "Cleaning, sanitation, and pest control services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvye6001r08mlhgal82ou",
        "name": "Clothing alteration and repair",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzke007908mlc4640b4h",
        "name": "Clothing rental",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvydo001q08ml4xvgfhgl",
        "name": "Clothing stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy21000u08mlfernbp2r",
        "name": "Computer equipment",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxtm000a08mlc33qf5sm",
        "name": "Concrete services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz86005e08mlc63abinn",
        "name": "Consumer electronics repair and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyaa001b08ml4uj9b2qc",
        "name": "Convenience stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvypb003208mld49dca8l",
        "name": "Cosmetic supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzn8007k08ml806zcml0",
        "name": "Cosmetic, health spas, and relaxation massage services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyzx004p08mlds5v33k7",
        "name": "Courier and freight delivery services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyet001x08ml59qzamy4",
        "name": "Curtains, blinds, and window coverings",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzm5007i08mlcxn8dmcb",
        "name": "Dating and matchmaking services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzfy006m08ml2tqk0qni",
        "name": "Dental and medical laboratories",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzeu006f08ml3vuf6fub",
        "name": "Dental services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzjv007708mldu57h4em",
        "name": "Digital gaming products and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzed006e08ml8jxcfkbq",
        "name": "Doctors and physicians",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvymj002p08ml2n2da6nf",
        "name": "Duty free stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzds006a08ml118e2eta",
        "name": "Education (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pjr2ou000009l8hi2se31x",
        "name": "Electric vehicle charging services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxu8000c08mlc95b5sfd",
        "name": "Electrical supplies and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxsi000708mlgk8ogd33",
        "name": "Electricity and gas services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_clahc65qk000008jt7nug6ag9",
        "name": "Electricity services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyge002108mlfe0l2thb",
        "name": "Electronic and appliance stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzah005u08ml8vyq4fhw",
        "name": "Employment and career services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzi5006v08mlg3pndlk0",
        "name": "Entertainment (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzbl006108ml1c9o0tn8",
        "name": "Event venue and equipment rental",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzi7006w08ml6blq7e83",
        "name": "Events and tickets (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvygg002308ml8p0z179o",
        "name": "Fabric, sewing, knitting, and related supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvywi004508mlacrd41wf",
        "name": "Fast food stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pgeu3q000109i4368cg786",
        "name": "Financial advice and wealth management",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzc2006208ml5mg1cxf7",
        "name": "Financial asset brokers, exchanges, and managed funds",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz23005008ml7hg16o7w",
        "name": "Financial services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyfa001y08mlgbl1f1vu",
        "name": "Fireplaces and supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_clahchmg0000108mo8cnf2bs2",
        "name": "Fish and seafood supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyes001w08mleewb7dfd",
        "name": "Floor covering stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxwd000i08ml5o99fokj",
        "name": "Floral supplies and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz22004z08ml32530yob",
        "name": "Foreign exchange and money transfer services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvytq003o08mlbcy57jft",
        "name": "Fuel stations",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzm3007h08mlfc7l56zp",
        "name": "Funeral, death, and memorial services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_clahc7wwq000108jt06fy6lvo",
        "name": "Gas services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvybd001f08ml8w4y3yor",
        "name": "General retail stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyo6002y08mlfafxgd3o",
        "name": "Gift and souvenir stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzis007108ml1fj7f1md",
        "name": "Golf courses",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvywj004608mlho382gvn",
        "name": "Gyms, fitness, aquatic facilities, yoga, pilates",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzm2007g08ml8m0q4ury",
        "name": "Haircuts and treatments",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxz8000n08ml5gcoffpm",
        "name": "Hardware equipment and supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxu5000b08ml7aske9u7",
        "name": "Heating, cooling, and ventilation equipment and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyjt002i08mlbpv4gyx0",
        "name": "Hobby, toy, and physical game stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyfc001z08ml7yeugcst",
        "name": "Home furnishing and repair stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_cl9c9l15j000009kv8ml01tk7",
        "name": "Hospices",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzeb006c08mlakege133",
        "name": "Hospitals and emergency care",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyux003x08mlgwyo6uq6",
        "name": "Hotels, motels, and other temporary accommodation",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz7m005b08mlgher9mt4",
        "name": "IT and software development services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy8o001808ml9ld14mx1",
        "name": "Ice cream, gelato, nut, and confectionary stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy0c000p08mlh2606qt0",
        "name": "Industrial and commercial supplies (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz1k004y08ml25j2erby",
        "name": "Insurance",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pejp4g000109mae32z2zhb",
        "name": "Internet services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxvc000g08ml2oiybbks",
        "name": "Landscaping, garden, and horticultural services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzkg007b08mlh3higeon",
        "name": "Laundry and drycleaning",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz88005g08mlb63z0a4l",
        "name": "Legal services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_cl15vdeg8000009l32o2v1ory",
        "name": "Lending services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_cl37t9teq000009jwdq7dgqzi",
        "name": "Libraries",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyac001c08mlbyp5doni",
        "name": "Liquor stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pbn9e4000009mp382ddhbq",
        "name": "Local government",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000thk4mefilhht7",
                "name": "Housing"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz9u005o08ml2oi20hre",
        "name": "Management consulting",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyhl002a08ml39u6clb6",
        "name": "Marinas, marine supplies, and marine services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxuq000d08ml81pqa16w",
        "name": "Masonry, stonework, tiling, plastering, and insulation services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckpyo79om000009kw58cq8czp",
        "name": "Meal kit stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy8m001708ml68px9wcf",
        "name": "Meat supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzhn006t08mlg81xhlbx",
        "name": "Media and entertainment streaming services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzec006d08ml1xjz1di1",
        "name": "Medical products and supplies (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_cl9rwlp2s000009l3gmy97xxj",
        "name": "Medical services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzpe007t08mlfiorez29",
        "name": "Membership organisations (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyvg004008ml6zun9stl",
        "name": "Motor parks, campgrounds, holiday parks, recreational camps",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyn2002r08ml4n8t4uja",
        "name": "Musical equipment, recordings, and supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzbk006008ml1ks82is1",
        "name": "National government services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvylz002l08ml6nra9enk",
        "name": "Newspapers, magazines, and literary subscriptions",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvymi002o08mlgf5wdvfj",
        "name": "Nurseries and garden supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzfg006k08ml56i13bn6",
        "name": "Optometrists and eyewear",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy0t000q08mlhm1r54o5",
        "name": "Painting supplies and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyza004j08ml2jqr21bt",
        "name": "Parking services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzjc007408mlh0ev5y3t",
        "name": "Performing art training",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pkk8ir000009mu1xi353mv",
        "name": "Personal software (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvypt003408mle59z71f4",
        "name": "Pets and related supplies, accommodation, and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyn3002s08mle90qdtmo",
        "name": "Pharmacies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzll007f08ml4qgd4xud",
        "name": "Photography equipment and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pa65jm000009mfh2jm7d4m",
        "name": "Physiotherapy and massage therapy",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy0a000o08mlfln095js",
        "name": "Plumbing and gasfitting supplies and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzow007r08ml5eqa16dv",
        "name": "Political organisations",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz0g004r08ml7f3hcr57",
        "name": "Postal services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzd6006508mle0ctar1e",
        "name": "Primary and secondary schools",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxni000208mlbhugb1za",
        "name": "Printing, publishing, and signmaking services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzbi005y08ml37j1haap",
        "name": "Professional services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzh3006p08ml37o7790t",
        "name": "Psychology, psychiatric, counselling, and other mental health services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pn4a9q000009mj374t2o6n",
        "name": "Real estate services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvznt007o08mlfyzdaj9q",
        "name": "Religious organisations",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pae1ns000009jt55t2cdir",
        "name": "Rent for permanent accomodation",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000thk4mefilhht7",
                "name": "Housing"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyr0003d08ml0xgx2x58",
        "name": "Repair and servicing (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzdt006b08mlc16xeila",
        "name": "Retirement accommodation",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000thk4mefilhht7",
                "name": "Housing"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxt3000908mlb6xj9x5z",
        "name": "Roofing services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyn4002t08ml54k15mgr",
        "name": "Secondhand and opportunity stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzay005v08mlfxmbal3g",
        "name": "Security stores and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvypx003708ml1ju5813w",
        "name": "Shoe and leather repair, keycutting, or engraving",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvycl001o08ml7wxo8w4j",
        "name": "Shoe stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckpyo8lga000109kw7pyhcdxw",
        "name": "Specialty food stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvypw003608mld98b9yes",
        "name": "Specialty retail stores (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvziq006z08mldbw7eyne",
        "name": "Sports and athletic clubs",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyio002f08ml0kh60x4i",
        "name": "Sports equipment and supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyi2002b08mlh2elakks",
        "name": "Stationery and office supplies",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyzv004n08mlae0hf8u1",
        "name": "Storage facilities",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvy84001608ml5p6z4d8j",
        "name": "Supermarkets and grocery stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000xhk4mf7mg2j1z",
                "name": "Food"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvypv003508mlda344tpi",
        "name": "Swimming pools, supplies, and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzbj005z08mle3z667go",
        "name": "Tax payments",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyxm004c08mlexbea79o",
        "name": "Taxi, rideshare, and on-demand transport services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz0y004t08ml8zey1jiv",
        "name": "Telecommunication services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz4d005808mlciyi37f8",
        "name": "Testing laboratories (non medical)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0012hk4mgru5dgy7",
                "name": "Professional Services"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzjd007508mld8zqd622",
        "name": "Theatre, concerts, and other artistic performances",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyy9004i08mlcl4jhggy",
        "name": "Toll fees",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyuv003v08ml7434fnid",
        "name": "Towing services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxva000f08ml7fibefq1",
        "name": "Trade services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_clahcfil5000008mogwg5hdr7",
        "name": "Train and rail transport services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyy8004h08ml568d813k",
        "name": "Transport services (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyzc004l08mlhc8da1l3",
        "name": "Travel agencies and tour operators",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvz4b005608ml2ygi4sq1",
        "name": "Truck, trailer, machinery, and equipment rentals",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyso003n08ml83zy0lyv",
        "name": "Tyre stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxkq000008mlfvf6gi1f",
        "name": "Uniforms and commercial clothing",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzd7006608mlh6652doj",
        "name": "Universities, professional schools, and other tertiary education",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000zhk4m0cru14rw",
                "name": "Education"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvybf001g08mlczajat62",
        "name": "Variety stores",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvys3003i08mlhtk95p7h",
        "name": "Vehicle dealers (not elsewhere classified)",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000whk4m577xhmf3",
                "name": "Transport"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzh1006o08mlbn8m2q1f",
        "name": "Veterinary services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000yhk4mddaobwu7",
                "name": "Health"
            }
        }
    },
    {
        "_id": "nzfcc_ckq5t8pp9000009jvbego537k",
        "name": "Waste and recycling services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvyqy003b08ml65aj5svx",
        "name": "Watch, clock, and jewellery stores and services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0010hk4mf2dca4y8",
                "name": "Appearance"
            }
        }
    },
    {
        "_id": "nzfcc_cl2pehre5000009ma7a3rdh1b",
        "name": "Water and sanitation services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000vhk4m46ce9nrt",
                "name": "Utilities"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvxrz000608ml3pgqfx3i",
        "name": "Welding, fabrication, and metal services",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw000uhk4m20nvc6m1",
                "name": "Household"
            }
        }
    },
    {
        "_id": "nzfcc_ckouvvzh4006q08mla1rt5w8j",
        "name": "Welfare and charity",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    },
    {
        "_id": "nzfcc_ckphrdp9f000008ml5t9g7d0m",
        "name": "Wineries, breweries, and distilleries",
        "groups": {
            "personal_finance": {
                "_id": "group_clasr0ysw0011hk4m6hlk9fq0",
                "name": "Lifestyle"
            }
        }
    }
];